'use strict'

const u = require('universalify').fromCallback
module.exports = {
  copy: u(require('./copy'))
}



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-core/~/fs-extra/lib/copy/index.js
// module id = 2059
// module chunks = 0 1